// extracted by mini-css-extract-plugin
export var active = "_l7-2";
export var recordingDot = "_l7-1";
export var recordingIndicator = "_l7-0";